// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MuiTabs-scroller .MuiTab-root{min-width:100px}`, "",{"version":3,"sources":["webpack://./src/EmploymentBillboard/App/EmployeeDashboard/Desktop/DesktopPanelContainer/DesktopPanelContainer.scss"],"names":[],"mappings":"AAAA,+BACI,eAAA","sourcesContent":[".MuiTabs-scroller .MuiTab-root {\r\n    min-width: 100px;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
